
import { Component, Inject, Vue } from "vue-property-decorator";
import VueApexCharts from "vue-apexcharts";
import { Container } from "inversify";
import OrganizationTable from "../molecules/explorer-tool/OrganizationTable.vue";
import { OrganizationCollectionStore } from "../stores/industry-analytics/OrganizationCollectionStore";
import Loader from "../molecules/components/Loader.vue";
import { OrganizationFilterStore } from "../stores/organization/OrganizationFilterStore";
import LoadingOverlay from "../../../common/src/components/LoadingOverlay.vue";
import NoRecords from "../../../common/src/components/NoRecords.vue";
import FilterContainer from "../molecules/organization/FilterContainer.vue";
import NewOrganizationList from "../molecules/industry-analytics/NewOrganizationList.vue";
import ServiceDistributionLevel1 from "../molecules/industry-analytics/ServiceDistributionLevel1.vue";
import ServiceDistributionLevel2 from "../molecules/industry-analytics/ServiceDistributionLevel2.vue";
import ProductDistributionLevel1 from "../molecules/industry-analytics/ProductDistributionLevel1.vue";
import OrgsFoundingYear from "../molecules/industry-analytics/OrgsFoundingYear.vue";
import SectorsByCountry from "../molecules/industry-analytics/SectorsByCountry.vue";
import OwnershipType from "../molecules/industry-analytics/OwnershipType.vue";
import InHouseManufacturing from "../molecules/industry-analytics/InHouseManufacturing.vue";
import InternalManufacturing from "../molecules/industry-analytics/InternalManufacturing.vue";
import ProductDistributionLevel2 from "../molecules/industry-analytics/ProductDistributionLevel2.vue";
import StatisticsContainer from "../molecules/industry-analytics/StatisticsContainer.vue";
import { OrganizationListStore } from "../stores/organization/OrganizationListStore";
import RecentlyFoundedOrganizationList from "../molecules/industry-analytics/RecentlyFoundedOrganizationList.vue";
import CountryFilter from "../molecules/organization/CountryFilter.vue";
import { handleError } from "../../../common/src/utility/errorUtils";

@Component({
    components: {
        CountryFilter,
        RecentlyFoundedOrganizationList,
        StatisticsContainer,
        ProductDistributionLevel2,
        SectorsByCountry,
        OwnershipType,
        InHouseManufacturing,
        OrgsFoundingYear,
        InternalManufacturing,
        ProductDistributionLevel1,
        ServiceDistributionLevel1,
        ServiceDistributionLevel2,
        NewOrganizationList,
        FilterContainer,
        NoRecords,
        LoadingOverlay,
        Loader,
        OrganizationTable,
        VueApexCharts,
    },
})
export default class IndustryAnalyticsView extends Vue {
    @Inject("container") readonly container!: Container;
    organizationCollectionStore: OrganizationCollectionStore = this.container.get(
        OrganizationCollectionStore,
    );
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    organizationFilterStore: OrganizationFilterStore = this.container.get(OrganizationFilterStore);

    chartHeight = "250px";

    created() {
        this.organizationListStore.load().catch(handleError);
    }
}
